'use strict';

module.exports = ['$scope', 'ngDroUAA', 'ngDroUtilsNotify', function ($scope, ngDroUAA, ngDroUtilsNotify) {

        /*
         * Init
         */

        $scope.myImage = '';
        $scope.myCroppedImage = '';
        $scope.invalidFile;                 // vedo se il file è supportato o meno
        var selected_file = null;           // mantengo info del file selezionato

        /*
         * Methods
         */

        // Funzione invocata ogni volta che viene selezionato un file. Necessaria per il funzionamento della libreria ngImgCrop
        $scope.uploadFile = function (file, el) {
            if (file) {
                selected_file = file;
                $scope.invalidFile = !file.name.match(/.(jpg|jpeg|png|gif)$/i);
                // ng-img-crop
                var imageReader = new FileReader();
                imageReader.onload = function (image) {
                    $scope.$apply(function ($scope) {
                        $scope.myImage = image.target.result;
                    });
                };
                imageReader.readAsDataURL(file);
            } else {
                // Se metti cancel nella finsetra, non hai più il file selezionato nel field input, e se
                // fai submit ti dice che manca il file, anche se vedi le immagini. Allora le elimino 
                $scope.myImage = '';
                $scope.myCroppedImage = '';
                selected_file = null;
            }

        };

        // La libreria ngImgCrop ritorna l'immagine selezionata in base64, con 2 parametri anteposti (vedi split);
        // Questa funzione splitta e converte poiche il server vuole il Blob. 
        function fromBase64toBlob(base64data) {
            // Assuming we have the crop result in base64data
            // Get the mime part of it
            var mimeString = base64data.split(',')[0].split(':')[1].split(';')[0];
            // Get the data part as base64
            var base64 = base64data.split(',')[1];
            // Decode it as blob
            var dataString = window.atob(base64);
            var dataArray = [];
            for (var i = 0; i < dataString.length; i++) {
                dataArray.push(dataString.charCodeAt(i));
            }
            var imageData = new Blob([new Uint8Array(dataArray)], {type: mimeString});
            return imageData;
        }

        // Submit della form di modifica della thumbnail.
        $scope.thumbSubmit = function (croppedData, isValid) {
            // creo il payload della post
            var payload = new FormData();
            payload.append('file', fromBase64toBlob(croppedData), selected_file.name);
            payload.append('id', $scope.person.id);

            if (isValid) {
                ngDroUAA.Profile.updateBadge(payload)
                        .then(function (data) {
                            ngDroUtilsNotify.updateSuccess($scope.person.firstName.sformat($scope.person.lastName));
                            // Potresti evitare la chiamata rest successiva, ma è meglio riscaricarti l'immagine
                            // ad esempio il server potrebbe fare qualche modifica (tagliarla, watermark, ecc)
                            
                            ngDroUAA.Profile.getBadge($scope.person.id).then(function (response) {
                                $scope.user.thumb = {};
                                $scope.user.thumb.data = response.data;
                                $scope.user.thumb.type = response.headers('Content-Type');
                            });

                        })
                        .catch(function (err) {
                            ngDroUtilsNotify.updateError($scope.person.firstName.sformat($scope.person.lastName),err);

                        });
            }
        };

        // Chiusura della finestra.
        $scope.cancel = function () {
            $scope.myImage = '';
            $scope.myCroppedImage = '';
            selected_file = null;
        };
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/profile/profileDetail/tabs/thumb-form.js
// module id = 407
// module chunks = 0